import React from "react";

function VPOPCountryStatus({ country }) {
  if (!country) return null;

  const currentYear = country.year || new Date().getFullYear();

  return (
    <div className="flex flex-col">

      {/* Stats Row */}
      <div className="flex gap-16 text-sm">

        {/* Gavi Co-Financing */}
        <div className="flex flex-col">
          <span className="font-semibold text-gray-800">{currentYear} Gavi Co-Financing</span>
          <span className="text-gray-900">
            {country.gavi_cofinancing || "—"}
          </span>
        </div>

        {/* Birth Cohort */}
        <div className="flex flex-col">
          <span className="font-semibold text-gray-800">{currentYear} Birth Cohort</span>
          <span className="text-gray-900">
            {country.birth_cohort
              ? country.birth_cohort.toLocaleString()
              : "—"}
          </span>
        </div>

      </div>
    </div>
  );
}

export default VPOPCountryStatus;
